// extracted by mini-css-extract-plugin
export var container = "_ag-0";
export var icon = "_ag-1";
export var text = "_ag-2";